import {
  GetTeamAuditHistoryResponse,
  Id,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const getTeamAuditHistory = (
  req: Partial<Id>
): Promise<GetTeamAuditHistoryResponse> =>
  request({
    url: '/service/userv2service/GetTeamAuditHistory',
    body: req,
  }).then((r) => r.body);
